import React from 'react';
import './ColumnProgress.css';

/** 4 px done/total bar + "N open" (card 3.2). Shared by the Kanban column
 *  header and the List view group header (list 6). `progress` is the
 *  { total, done, open, pct } object from boardProgress.groupProgress. */
export default function ColumnProgress({ progress, className = '' }) {
  const { total = 0, done = 0, open = 0, pct = 0 } = progress || {};
  return (
    <div className={`task-board-progress${className ? ` ${className}` : ''}`}>
      <div
        className="task-board-progress-track"
        role="progressbar"
        aria-label="List progress"
        aria-valuetext={`${done} of ${total} done`}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={done}
      >
        <div className="task-board-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="task-board-progress-text">{total === 0 ? 'No tasks' : open === 0 ? 'All done' : `${open} open`}</span>
    </div>
  );
}
